/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {selectTransferOption} from '../api'

export const useMutationSelectTransferOption = createReactQueryMutationHook('selectTransferOption', selectTransferOption)
